/* eslint-disable no-nested-ternary */
import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {ColumnChooser} from '@components/column-chooser'
import {DivWithHint} from '@components/common/hint/hint'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {Menu} from '@components/menu'
import {noPropagate} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import {useProjectParticipantStore} from './project-participants-store'

export const RolesTab = observer(() => {
  const [state, store] = useProjectParticipantStore()

  const bem = Util.bemFrom('project-participants')

  return (
    <div
      className={cn(bem('role-list'), 'max-h-[calc(100%-109px-28px)] h-full')}
    >
      <div className={bem('add-role')} onClick={store.createRole}>
        {Lang.msg.proj.addRole}
      </div>
      <div className={bem('add-or-copy')}>{Lang.msg.proj.or}</div>
      <div className={bem('copy-role')} onClick={store.setCopyRoleOn}>
        {Lang.msg.proj.copyRole}
        {state.copyRole && (
          <Menu onEscape={store.setCopyRoleOff}>
            <div className={bem('overlay')} onClick={store.setCopyRoleOff} />
            <div className={bem('move')} onClick={noPropagate}>
              {state.copyRole && (
                <ColumnChooser
                  onChoose={store.onCopyRole}
                  chooseRoles={true}
                  filter={h => h.id !== store.props.project?.id}
                />
              )}
            </div>
          </Menu>
        )}
      </div>

      <WithPerfectScrollbar
        className={cn('min-h-100', 'max-h-[calc(100%-32px)]')}
      >
        {store.getCustomRoles().map(r => {
          const click = () => store.setEditedRole(r)
          return (
            <div
              key={r.key}
              className={bem('role-item', {custom: true})}
              onClick={click}
            >
              <div className={bem('role-title')}>{r.name}</div>
              <div className={bem('role-descr')}>
                {r.description || Lang.msg.proj.roleNoDescr}
              </div>
              <div onClick={noPropagate}>
                <DivWithHint
                  className={bem('role-del')}
                  content={Lang.msg.proj.deleteRole}
                  onClick={() => store.deleteRole(r)}
                />
              </div>
            </div>
          )
        })}
        <div className={bem('role-item')}>
          <div className={bem('role-title')}>
            {Lang.msg.permission.adminRole}
            <div className={bem('system-role')}>
              ({Lang.msg.proj.systemRole})
            </div>
          </div>
          <div className={bem('role-descr')}>
            {Lang.msg.permission.adminRoleDescription}
          </div>
        </div>
        <div className={bem('role-item')}>
          <div className={bem('role-title')}>
            {Lang.msg.permission.workerRole}
            <div className={bem('system-role')}>
              ({Lang.msg.proj.systemRole})
            </div>
          </div>
          <div className={bem('role-descr')}>
            {Lang.msg.permission.workerRoleDescription}
          </div>
        </div>
        <div className={bem('role-item')}>
          <div className={bem('role-title')}>
            {Lang.msg.permission.observerRole}
            <div className={bem('system-role')}>
              ({Lang.msg.proj.systemRole})
            </div>
          </div>
          <div className={bem('role-descr')}>
            {Lang.msg.permission.observerRoleDescription}
          </div>
        </div>
      </WithPerfectScrollbar>
    </div>
  )
})
